// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6566d8dc","743":"e1158964"}[chunkId] + ".chunk.js";
};